import { Injectable } from '@angular/core';
import { CreateNewVariantRequest } from '../classes/SongVariant';

export enum SongDraftIntent {
  CreateSong = 'create_song',
}

@Injectable({
  providedIn: 'root'
})
export class SongDraftService {

  constructor() { }

  private draftKey = "song_creation_draft";

  saveDraft(payload: CreateNewVariantRequest) {
    localStorage.setItem(this.draftKey, JSON.stringify(payload));
  }

  getDraft(): CreateNewVariantRequest | null {
    const data = localStorage.getItem(this.draftKey);
    return data ? JSON.parse(data) : null;
  }

  hasDraft(): boolean {
    return localStorage.getItem(this.draftKey) !== null;
  }

  clearDraft() {
    localStorage.removeItem(this.draftKey);
  }

}
